import React, { useState, useEffect } from 'react';
import { fetchMissions } from "../Apis/AdminApis";
import './ViewMissions.css';
import Sidebar from "../Sidebar/Sidebar";
import pavamanLogo from "../images/drone.png"; 

const ViewMissions = () => {
  const [missions, setMissions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    loadMissions();
  }, []);

  const loadMissions = async () => {
    try {
      setLoading(true);
      const data = await fetchMissions();
      setMissions(data.vehicles || []);
      setError(null);
    } catch (err) {
      setError('Failed to load missions');
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const getStatusColor = (status) => {
    switch (status) {
      case 'active': return 'vm-status-active';
      case 'completed': return 'vm-status-completed';
      case 'paused': return 'vm-status-paused';
      case 'failed': return 'vm-status-failed';
      default: return 'vm-status-unknown';
    }
  };

  const formatDateTime = (dateString) => {
    if (!dateString) return 'N/A';
    return new Date(dateString).toLocaleString();
  };

  return (
    
    <div className="dashboard-wrapper">
        <Sidebar />
        <div className="dashboard-content">
      <div className="dashboard-header">
        <h2 className="page-title">Mission Overview</h2>
        <button 
          className="vm-refresh-btn"
          onClick={loadMissions}
          disabled={loading}
        >
          {loading ? 'Refreshing...' : 'Refresh'}
        </button>
      </div>

      {error && (
        <div className="vm-error">
          <span className="vm-error-icon">⚠</span>
          {error}
        </div>
      )}

     {loading ? (
  <div className="custom-loading-container">
    <img
      src={pavamanLogo}
      alt="Loading"
      className="spinning-logo"
    />
    <p className="loading-text">
      Loading active pilots...
    </p>
  </div>

      ) : missions.length === 0 ? (
        <div className="vm-empty">
          <p>No missions found</p>
        </div>
      ) : (
        <div className="vm-grid">
          {missions.map((vehicle, idx) => (
            <div key={vehicle.vehicle_id || idx} className="vm-card">
              <div className="vm-card-header">
                <h3 className="vm-vehicle-id">
                  Vehicle: {vehicle.vehicle_id || 'Unknown'}
                </h3>
                <div className="vm-meta">
                  <span className="vm-admin">Admin: {vehicle.admin_id}</span>
                  <span className="vm-pilot">Pilot: {vehicle.pilot_id || 'N/A'}</span>
                </div>
              </div>

              <div className="vm-missions-list">
                <h4 className="vm-missions-title">
                  Missions ({vehicle.missions?.length || 0})
                </h4>
                {vehicle.missions?.map((mission, mIdx) => (
                  <div key={mission.mission_id || mIdx} className="vm-mission-item">
                    <div className="vm-mission-header">
                      <span className="vm-mission-id">
                        Mission ID: {mission.mission_id}
                      </span>
                      <span className={`vm-status ${getStatusColor(mission.status)}`}>
                        {mission.status || 'Unknown'}
                      </span>
                    </div>
                    
                    <div className="vm-mission-details">
                      <div className="vm-detail-row">
                        <span className="vm-detail-label">Paused At:</span>
                        <span className="vm-detail-value">
                          {formatDateTime(mission.paused_at)}
                        </span>
                      </div>
                      <div className="vm-detail-row">
                        <span className="vm-detail-label">Resumed At:</span>
                        <span className="vm-detail-value">
                          {formatDateTime(mission.resumed_at)}
                        </span>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
    </div>
  );
};

export default ViewMissions;